// Supabase auth redirects carry session credentials in the URL: the implicit
// flow puts access_token/refresh_token in the fragment, the PKCE flow puts a
// one-time `code` in the query. Analytics must never store them (#332).

const AUTH_PARAMS = ['access_token', 'refresh_token', 'provider_token', 'provider_refresh_token', 'code', 'token_hash'];

function redactParams(params: URLSearchParams): boolean {
  let changed = false;
  for (const key of AUTH_PARAMS) {
    if (params.has(key)) {
      params.set(key, 'REDACTED');
      changed = true;
    }
  }
  return changed;
}

/** Returns the URL with auth credentials replaced by REDACTED; other values pass through unchanged. */
export function redactAuthUrl(value: string): string {
  if (!AUTH_PARAMS.some((key) => value.includes(`${key}=`))) return value;
  let url: URL;
  try {
    url = new URL(value, 'https://placeholder.invalid');
  } catch {
    return value;
  }
  const query = new URLSearchParams(url.search);
  const fragment = new URLSearchParams(url.hash.slice(1));
  const queryChanged = redactParams(query);
  const fragmentChanged = redactParams(fragment);
  if (queryChanged) url.search = query.toString();
  if (fragmentChanged) url.hash = fragment.toString();
  const out = url.toString();
  // Relative inputs (e.g. $pathname) come back relative.
  return value.startsWith('/') ? out.replace('https://placeholder.invalid', '') : out;
}
